import enLocale from '@/views/app/src/locale/en.yml';
import frLocale from '@/views/app/src/locale/fr.yml';
import { watchEffect } from 'vue';
import { useI18n, createI18n as vueCreateI18n, type I18nOptions } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { datetimeFormats } from './locales/datetime-formats';
import { numberFormats } from './locales/number-formats';

export enum SupportedLanguages {
  FRENCH = 'fr',
  ENGLISH = 'en',
}

export type SupportedLanguage = `${SupportedLanguages}`;

export const defaultI18nOptions: I18nOptions = {
  legacy: false,
  fallbackLocale: SupportedLanguages.ENGLISH,
  locale: SupportedLanguages.ENGLISH,
  numberFormats,
  datetimeFormats,
};

export function fetchBrowserLanguage(routeQuery?: Record<string, any>) {
  const queryLocale = routeQuery?.locale;

  if (queryLocale === SupportedLanguages.FRENCH) return SupportedLanguages.FRENCH;
  if (queryLocale === SupportedLanguages.ENGLISH) return SupportedLanguages.ENGLISH;

  const browserLanguage = navigator.language;
  if (browserLanguage.startsWith(SupportedLanguages.FRENCH)) return SupportedLanguages.FRENCH;
  return SupportedLanguages.ENGLISH;
}

export function createI18n(options: I18nOptions = {}) {
  options.messages = { en: enLocale, fr: frLocale };
  const mergedOptions: I18nOptions = { ...defaultI18nOptions, ...options };
  const instance = vueCreateI18n(mergedOptions);

  return instance;
}

export function useSetLanguage() {
  const { locale } = useI18n({ useScope: 'global' });
  const route = useRoute();

  watchEffect(() => {
    document.querySelector('html')?.setAttribute('lang', locale.value as string);
  });

  watchEffect(() => {
    const detectedLocale = fetchBrowserLanguage(route.query);

    if (detectedLocale === SupportedLanguages.FRENCH) {
      locale.value = SupportedLanguages.FRENCH;
    }
  });
}
